import { Box, Button, styled, Typography } from '@mui/material';
import analytics from '@/utils/analytics/analyticsInstance';
import FindiesLogo from '@/assets/images/findies-logo-light.png';
import config from '@/types/config';

const Container = styled(Box)(() => ({
  flex: 1,
  padding: 20,
  display: 'flex',
  justifyContent: 'center',
  background:
    'radial-gradient(120% 60% at 50% 105%, #ffd666 0%, rgba(255,214,102,0.65) 22%, rgba(255,214,102,0) 58%), linear-gradient(180deg, #61a3ff 0%, #8b90c2 32%, #d1848f 58%, #ee9566 78%,#f2b450 100%)',
}));

const Main = styled(Box)(() => ({
  flex: 1,
  gap: 24,
  maxWidth: 600,
  flexDirection: 'column',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Logo = styled('img')(() => ({
  width: 143,
  height: 36,
}));

export default function SignUpPage() {
  const handleNavigate = async () => {
    await analytics.track('webContentElementClicked', {
      content_source: window.location.href,
      element: 'Sign Up',
    });

    window.open(config.oneLinkUrl, '_blank');
  };

  return (
    <Container>
      <Main>
        <Logo src={FindiesLogo} alt="Findies" />
        <Typography
          fontSize={24}
          color="white"
          fontWeight={700}
          lineHeight="40px"
          textAlign="center"
        >
          Discover what others love and shop with cashback
        </Typography>
        <Button onClick={handleNavigate} variant="contained" size="large" fullWidth>
          Sign Up
        </Button>
      </Main>
    </Container>
  );
}
